<template>
    <div class="full-screen reports-section eod-reports" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
      <div class="app-bg-gradient">
        <div class="stars-bg"></div>
      <div class="cursor back" @click="movetoReports">{{"Back" | translate}}</div>
      <div class="flex flex-between sort-section">
        <div class="flex flex-between">
          <div>
            <select v-model="showBy">
              <option value="today">{{"Today" | translate}}</option>
              <option value="week">{{"Week" | translate}}</option>
              <option value="range">{{"Range" | translate}}</option>
            </select>
          </div>
          <div v-if="showBy === 'range'">
            <input type="date" v-model="rangeStartDate" :max="dateToday" @change="fromDateChange"/>
            <input type="date" v-model="rangeEndDate" :max="dateToday" :min="minToDate"/>
          </div>

          <div class="btn-bg1 reports-btn">
            <div class="btn-bg2">
              <button @click="eodReport" class="cursor login">{{"EOD Reports" | translate}}</button>
            </div>
          </div>

        </div>
        <div class="flex flex-between relative">
          <div>
            <select v-model="selectedTid">
              <option v-for="terminals in user.data.terminals" :value='terminals.tid' :key='terminals.tid'>{{terminals.tid}}</option>
            </select>
          </div>

          <div class="btn-bg1 reports-btn">
            <div class="btn-bg2">
              <button @click="postEodReport" class="cursor login">{{"New Report" | translate}}</button>
            </div>
          </div>

          <div v-if="terminalReqAvailability" class="error danger">{{terminalReqAvailability}}</div>
        </div>
      </div>
      <!--.reportLines.map(a => a.value).join("\n")-->
      <div v-if="eodReportsDetails">
          <div class="width-100">
            <div v-if="eodReportsDetails.length > 0" class="flex flex-between flex-align-top">
              <div class="width-70">
                <div class="transaction-data transaction-data-head flex head-row">
                  <div>{{"Terminal ID" | translate}}</div>
                  <div>{{"From" | translate}}</div>
                  <div>{{"Created At" | translate}}</div>
                </div>
                <div v-for="report in eodReportsDetails" @click="showFullReport(report)" :key="report.createdAt">
                  <div class="flex head-row report cursor" :class="activeReportClass(report)">
                    <div>{{ report.eod_report.tpi }}</div>
                    <div>{{ report.eod_report.balances.totalsSince }}</div>
                    <div>{{ report.createdAt | moment }}</div>
                  </div>
                </div>
              </div>
              <div v-if="activeReportId" class="eod-report-box">
                <pre>{{activeReportData}}</pre>
              </div>
            </div>
            <div v-if="eodReportsDetails.length <= 0">
              {{"No data found" | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import moment from 'moment'
    export default {
      data () {
        return {
          showBy: 'week',
          startOfDayEpoch: null,
          startOfWeekEpoch: null,
          endOfToday: null,
          dateToday: null,
          rangeStartDate: null,
          rangeEndDate: null,
          selectedTid: '22162165',
          activeReportId: null,
          activeReportData: null,
          minToDate: null,
          terminalReqAvailability: false
        }
      },
      computed: {
        ...mapGetters([
          'user',
          'token',
          'eodReportsDetails',
          'eodReports',
          'pageRedirectKey'
        ])
      },
      filters: {
        moment: function (date) {
          return moment(date).format('DD/MM/YYYY, h:mm')
        }
      },
      watch: {
        pageRedirectKey (newVal) {
          console.log(newVal)
        },
        eodReports (newValue) {
          if (newValue !== undefined) {
            if (newValue.reportType === 'END_OF_DAY') {
              this.postEODReports({tid: newValue.tpi || newValue.tid, reports: newValue})
              .then((result) => {
                console.log(result)
                this.showBy = 'today'
                this.eodReport()
              })
            }
          }
        },
        eodReportsDetails (newValue) {
          if (newValue.length > 0) {
            this.showFullReport(newValue[0])
          }
        }
      },
      methods: {
        ...mapActions([
          'getEODReports',
          'changeLoadingStatus',
          'eodReportRequest',
          'postEODReports',
          'pageRedirect'
        ]),
        showTerminalStatus () {
          this.terminalReqAvailability = 'Terminal not available'
          setTimeout(() => {
            this.terminalReqAvailability = false
          }, 3000)
        },
        activeReportClass (currentReport) {
          if (currentReport.id === this.activeReportId) {
            return 'active'
          } else {
            return ''
          }
        },
        showFullReport (d) {
          this.activeReportData = d.eod_report.reportLines.map(a => a.value).join('\n').trim()
          this.activeReportId = d.id
        },
        eodReport (l) {
          let range = {}
          let getReports = false
          if (l === 'load' || this.showBy === 'week') {
            range['from'] = this.startOfWeekEpoch
            range['to'] = this.endOfToday
            getReports = true
          } else if (this.showBy === 'today') {
            range['from'] = this.startOfDayEpoch
            range['to'] = this.endOfToday
            getReports = true
          } else {
            if (this.rangeStartDate && this.rangeEndDate) {
              range['from'] = +moment(this.rangeStartDate).startOf('day')
              range['to'] = +moment(this.rangeEndDate).endOf('day')
              getReports = true
            }
          }
          if (getReports) {
            this.getEODReports(range)
            .then((res) => {
              console.log(res)
            })
            .catch(error => {
              console.log(error)
            })
          }
        },
        fromDateChange () {
          this.rangeEndDate = null
          this.minToDate = this.rangeStartDate
        },
        postEodReport () {
          this.eodReportRequest({
            socket: this.$socket,
            tid: this.selectedTid
          })
        },
        movetoReports () {
          this.$router.push({name: 'Reports'})
        }
      },
      created: function () {
        this.selectedTid = this.user.data.terminals[0].tid
        this.startOfDayEpoch = +moment().startOf('day')
        this.startOfWeekEpoch = +(moment().startOf('week')._d)
        this.endOfToday = +(moment().endOf('day')._d)
        this.dateToday = moment(new Date()).format('YYYY-MM-DD')
      },
      mounted: function () {
        this.tid = this.$route.params.terminalId
        this.$nextTick(() => {
          // Check wether the user has been already logged in.
          if (!this.token) {
            this.$router.push({path: `/${this.tid}/`})
          } else {
            // this.terminalId = (this.userPDQTerminals[0] || [{}]).tid
            this.changeLoadingStatus(false)
          }
        })
        this.pageRedirect('reload')
        this.eodReport('load')
      }
    }
</script>
<style scoped>
    .reports-section {
        color: #FFF;
        height: 100vh;
        padding: 0;
    }
    .app-bg-gradient {
      padding: 25px 20px;
      height: 100%;
      overflow: hidden;
    }
    .eod-reports {
        padding: 0;
    }
    .heighlights-section {
      display: flex;
      margin-top: 30px;
    }
    select, input {
      border: 1px solid #FFF;
      background-color: transparent;
      border-radius: 0;
      height: 30px;
      padding: 0 30px 0 10px;
      outline: none;
      color: #FFF;
      margin-right: 5px;
      appearance: none;
      margin-right: 10px;
    }
    input[type="date"] {
      background-image: url('/static/images/drop-down-arrow.png');
      appearance: none;
      background-size : 14px;
      background-position: 90% 60%;
      background-repeat: no-repeat;
      padding-right: 10px !important;
    }
    input[type="date"]::-webkit-inner-spin-button,
    input[type="date"]::-webkit-calendar-picker-indicator {
        /* display: none; */
        -webkit-appearance: none;
    }
    input[type="date"]:hover {
      appearance: none;
    }
    .btn-bg1 {
      margin-top: 0;
    }
    .reports-btn.btn-bg1 {
      width: 140px !important;
    }
    .reports-btn .btn-bg2 {
      width: 132px !important;
    }
    .reports-btn .btn-bg2 button.login {
      width: 130px !important;
    }
    select option, select optgroup {
      margin: 40px;
      background: #333;
      color: #fff;
      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
  select option, select optgroup {
      margin: 40px;
      background: #880913;
      color: #fff;
      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
  option:checked {
    background: #fdc498 linear-gradient(0deg, #fdc498 0%, #fdc498 100%);
    color: #880913;
  }
  .head-row {
    padding: 5px;
  }
  .width-70 > .head-row:first-child {
    border-bottom: 1px solid #880913;
  }
  .head-row > div {
    width: 30%;
  }
  .width-100 {
    margin-top: 30px;
    width: 100%;
    position: relative;
    z-index: 4;
  }
  .width-70 {
    width: 70%;
    border: 1px solid #880913;
    height: 75vh;
    border-right: 0px;
    overflow-y: auto;
  }
  .active.report {
    background-color: #880913;
  }
  .eod-report-box {
    border: 1px solid #880913;
    padding: 10px;
    width: 30%;
    height: 75vh;
    overflow-y: auto;
  }
  select {
    background-position: 95% 59%;
  }
  .error {
    position: absolute;
    bottom: -20px;
  }
  .back {
    position: absolute;
    top: 20px;
    right: 50px;
    font-size: 20px;
    cursor: pointer;
    z-index: 4;
  }
  .sort-section {
    margin-top: 40px;
    z-index: 4;
    position: relative;
  }

    .transaction-data-head > div {
      color: #880913;
      font-weight: bold;
    }
  .full-screen {
    background-position: 50%;
}
div[dir='rtl'] select {
  background-position: 5% 60%;
  padding: 0 10px 0 30px !important;
  margin-right: initial;
  margin-left: 15px;
}
div[dir='rtl'] input {
  margin-right: initial;
  margin-left: 15px;
}
    @media only screen and (min-width: 2000px) {
      .heighlights-section {
        align-items: center;
        justify-content: space-around;
      }
      .reports-section {
        width: 100% !important;
        height: 100vh !important;
        padding: 0;
      }
      select {
        background-position: 95% 59%;
        background-size: 30px;
      }
      .app-bg-gradient {
        padding:5% 1%;
        overflow: hidden;
        height: 100vh;
      }
      .back {
        font-size: 90px;
        line-height: 90px;
        top: 50px;
        left: inherit;
        right:50px;
      }
      .sort-section {
        margin-top: 150px;
      }
      select, input {
        height: 100px;
        margin-right: 50px;
        font-size: 80px;
        line-height: 80px;
        border-width: 3px;
        appearance: none;
        width: max-content;
        padding: 0 52px 0 21px !important;
      }
      .btn-bg1 {
        margin-top: 0;
      }
      .width-70 > .head-row:first-child {
        height: 190px;
      }
      .head-row > div {
        font-size: 90px;
        line-height: 90px;
        padding-left: 1%;
      }
      .head-row {
        height: 200px;
        border-bottom: 1px solid red;
      }
      .eod-report-box {
        border: 1px solid #880913;
        padding: 30px;
        font-size: 75px;
        line-height: 89px;
      }
      .width-100 {
        margin-top: 5%;
        position: relative;
        z-index: 4;
      }
      .eod-report-box, .width-70 {
        height: 80vh;
      }
      .reports-btn.btn-bg1 {
        width: 450px !important;
      }
      .reports-btn .btn-bg2 {
        width: 440px !important;
      }
      .reports-btn .btn-bg2 button.login {
        width: 430px !important;
      }
      div[dir='rtl'] select {
        margin-left: 30px;
        padding-left: 65px !important;
      }
      div[dir='rtl'] input {
        margin-left: 30px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Reports/eodReports.vue